import { render } from "./AnnualReportsTable.vue?vue&type=template&id=185fdc8c"
import script from "./AnnualReportsTable.vue?vue&type=script&lang=js"
export * from "./AnnualReportsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__